var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileageGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.32,
    height: 33.71,
    viewBox: "22.7 27.1 42.32 33.71",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,83.000000) scale(0.100000,-0.100000)",
    fill: "#259160",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360 549 c-77 -31 -131 -110 -133 -195 -1 -72 47 -154 74 -127 5 5 -4 32 -18 62 -25 49 -26 56 -14 100 41 155 247 182 319 41 25 -49 26 -126 2 -155 -30 -37 -129 9 -115 54 8 27 -18 55 -43 47 -34 -11 -30 -59 6 -72 19 -8 31 -21 38 -45 10 -33 12 -34 59 -34 64 0 79 7 99 49 46 98 -9 226 -116 270 -42 18 -120 20 -158 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 484 c4 -21 22 -23 26 -1 2 10 -3 17 -13 17 -10 0 -15 -6 -13 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 456 c-14 -10 -15 -15 -6 -21 8 -4 19 -1 28 8 20 19 1 30 -22 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 453 c0 -5 5 -15 10 -23 7 -11 12 -12 21 -3 6 6 8 16 5 22 -8 12 -36 15 -36 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 355 c0 -11 7 -15 23 -13 12 2 22 8 22 13 0 6 -10 11 -22 13 -16 2 -23 -2 -23 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 358 c2 -7 10 -13 17 -13 7 0 15 6 18 13 2 7 -5 12 -18 12 -13 0 -20 -5 -17 -12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileageGreen);
export default __webpack_public_path__ + "static/media/mileage-green.4ce9ca9fb80fa46b315dcf8fdefacab2.svg";
export { ForwardRef as ReactComponent };